import { Component, inject, OnInit } from '@angular/core';

import { ActivatedRoute, RouterLink } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

import { TvoedSalaryService } from '@metallgehalt/tvoed-salary-calculator';

@Component({
  selector: 'tvoed-sub-tables',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './tvoed-sub-tables.component.html',
  styleUrl: './tvoed-sub-tables.component.scss'
})
export class TvoedSubTablesComponent implements OnInit {
  salaryService = inject(TvoedSalaryService);
  activatedRoute = inject(ActivatedRoute);
  titleService = inject(Title);
  metaService = inject(Meta);

  subTables: { key: string; name: string }[] = [];
  year!: number;

  ngOnInit() {
    this.year = this.activatedRoute.snapshot.params['tarifänderung'];
    this.titleService.setTitle(`TVöD Entgelttabelle ${this.year}`);
    this.metaService.updateTag({ name: 'description', content: `TVöD Entgelttabelle ${this.year} – Alle Bereiche: VKA, Bund, SuE, Pflege, Sparkassen` });
    this.metaService.updateTag({
      name: 'keywords',
      content: `TVöD, Entgelttabelle ${this.year}, TVöD VKA, TVöD Bund, TVöD SuE, TVöD Pflege, Gehaltstabelle öffentlicher Dienst`
    });

    this.salaryService.getSubTables(this.year).subscribe(subTables => {
      this.subTables = subTables;
    });
  }
}
